import styled, { css } from 'styled-components'

const checkedStyles = css`
  background: var(--global-color-orange-a-200);
  color: var(--color-text-neutral);
  border: 1px solid var(--global-color-orange-400);

  svg {
    color: var(--global-color-orange-500);
    fill: none;
  }

  &:hover {
    border: 1px solid var(--global-color-orange-500);
    transition: border 0.2s ease;
  }
`

export const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  cursor: pointer;
  padding: 8px;
  border-radius: var(--border-radius-sm);
  border: 1px solid var(--color-border-subtle);
  background: transparent;
  color: var(--color-text-neutral);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: border-color, background, color 0.15s ease;
  user-select: none;
  margin-right: 8px;

  .vrLight &,
  .vrDark & {
    border-radius: var(--border-radius-full);
  }

  &:last-of-type {
    margin-right: 0;
  }

  svg {
    margin-right: 6px;
    max-height: 12px;
    max-width: 10px;
    color: var(--color-text-neutral);
  }

  &:hover {
    .vrLight &,
    .vrDark & {
      background-color: var(--color-bg-a-subtle);
    }
  }

  &:has(input[type='checkbox']:checked) {
    ${checkedStyles}
  }
`

export const Input = styled.input`
  display: none;
`
